import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { createUseStyles } from "react-jss";
import { QuestionStyleType } from "types";

export const ButtonCheck: React.FC<QuestionStyleType> = ({
  section,
  question,
  formValues,
  handleButtonRatingClick,
}) => {
  const classes = useStyles();

  return (
    <Col xs={12}>
      {question.answers.map((answer, idx) => (
        <motion.div whileTap={{ scale: 0.97 }} key={idx}>
          <motion.div
            initial={{ opacity: 0, marginLeft: -25 }}
            animate={{ opacity: 1, marginLeft: 0 }}
            transition={{
              duration: 0.5,
              delay: idx / 8,
            }}
            className={`${classes.buttonRatingText} 
                          ${
                            formValues.find((q) => q.questionId === question.id)
                              ?.answer === answer
                              ? classes.selectedButton
                              : ""
                          }
                          `}
            onClick={() =>
              handleButtonRatingClick(
                section.sectionCode,
                question.id,
                answer,
                question.answers.length,
                question.measurable
              )
            }
          >
            <Row className="d-flex align-items-center">
              <Col className="text-end" xs={2}>
                <i
                  className={`las la-${
                    formValues.find((q) => q.questionId === question.id)
                      ?.answer === answer
                      ? "check-"
                      : ""
                  }circle`}
                  style={{ fontSize: 30 }}
                />
              </Col>
              <Col className="text-start">
                {question.answersMeaning![answer]}
              </Col>
            </Row>
          </motion.div>
        </motion.div>
      ))}
    </Col>
  );
};

const useStyles = createUseStyles({
  buttonRatingText: {
    color: "#404254",
    width: "100%",
    backgroundColor: "#FFF",
    boxShadow: "none",
    border: "1px solid #D2D7ED",
    margin: "5px 0",
    cursor: "pointer",
    padding: "10px 15px",
    textTransform: "uppercase",
    fontSize: 15,
    fontWeight: 700,
    borderRadius: 5,
  },
  selectedButton: {
    backgroundColor: "#EDEFF8",
  },
});
